export enum SellPointsSource {
    unknown = 0,
    courseCertification = 1,
    dailyLogin = 2,
    socialMediaShare = 3,
    referralInvited = 4,
    referralInviting = 5,
    courseRecertification = 1
}